import React, { Component } from 'react';
import ContainerDimensions from 'react-container-dimensions';
import styled from 'styled-components';

/* eslint-disable no-undef */

const Wrapper = styled.div`
	width: 100%;
  .cont {
    position: relative;
  }
  .touch {
    width: ${({ width }) => width ? `${width}px` : '46px'};
    height: 46px;
    background-color: #0798ff;
    border: none;
    border-radius: 0%;
    position: absolute;
    top: 0;
    cursor: pointer;
    left: 0;
    color: #fff;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
  }
  .round-left {
    border-radius: .5em 0 0 .5em;
  }
  .round-right {
    border-radius: 0 .5em .5em 0;
  }
  .line {
    background-color: #fff;
    border: 1px solid #575757;
    border-radius: .5em;
    height: 45px;
  }
  .range-label {
    padding-top: 1em;
    p {
      display: inline-block;
      color: #595959;
      font-weight: bold;
      font-size: .85em;
      &:first-child {
        float: left;
      }
      &:last-child {
        float: right;
      }
    }
  }
`;

class RangerInput extends Component {
  constructor(props) {
    super(props);
    this.state = { isDragging: false, posX: 0 };
    this.maxValue = null;
    this.onStart = this.onStart.bind(this);
    this.onMove = this.onMove.bind(this);
    this.onStop = this.onStop.bind(this);
    this.calculate = this.calculate.bind(this);
    this.handleMouseDown = this.handleMouseDown.bind(this); this.getRelPosX = this.getRelPosX.bind(this);
  }
  componentWillMount() {
  	const { min, defaultValue, value, onChange} = this.props;
  	if (value === 0) {
			setTimeout(() => onChange(min), 500);
		}
		if (defaultValue) {
			setTimeout(() => onChange(defaultValue), 500);
		}
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.isDragging && !prevState.isDragging) {
			document.addEventListener('touchmove', this.onMove);
			document.addEventListener('touchend', this.onStop);
      document.addEventListener('mousemove', this.onMove);
      document.addEventListener('mouseup', this.onStop);
    } else if (!this.state.isDragging && prevState.isDragging) {
      document.removeEventListener('mousemove', this.onMove);
      document.removeEventListener('touchmove', this.onMove);
      document.removeEventListener('mouseup', this.onStop);
      document.removeEventListener('touchend', this.onStop);
    }
    if (this.touchControl && this.touchControl.offsetParent) {
      const defaultWidth = parseInt(this.props.width, 10) || 46;
      this.maxValue = Math.floor(this.touchControl.offsetParent.getBoundingClientRect().width - defaultWidth);
    }
  }
  getRelPosX() {
    const defaultWidth = parseInt(this.props.width, 10) || 46;
    const minValue = this.props.min;
    const maxValue = this.props.max;
    const value = this.props.value ? this.props.value : minValue;
    const pos = (value - minValue) / ((maxValue - minValue) / 100);
    return (pos * (this.width - defaultWidth)) / 100.0;
  }
  onStart(e) {
    //if (e.button !== 0 || e.touches.length !== 1) return;
    const sliderPos = this.touchControl.getBoundingClientRect();
    this.setState({
      isDragging: true,
      posX: sliderPos.left - this.getRelPosX()
    });
    e.stopPropagation();
    e.preventDefault();
  }
  onMove(e) {
    const defaultWidth = parseInt(this.props.width, 10) || 46;
    const pageX = e.pageX || (e.touches ? e.touches[0].pageX : 0);
    const maxPosX = this.touchControl.offsetParent.getBoundingClientRect().width - defaultWidth;
    const val = Math.max((pageX - (defaultWidth / 2)) - this.state.posX, 0);
    const relPosX = Math.min(val, maxPosX);
    this.calculate(relPosX);
  }
  onStop(e) {
    if (!this.state || !this.state.isDragging) return;
    this.setState({ isDragging: false });
    e.stopPropagation();
    e.preventDefault();
  }
  calculate(relPosX) {
    const val = Math.ceil((Math.floor(relPosX) * 100) / this.maxValue);
    const currentValue = this.props.type === 'float' ? ((relPosX * 100) / this.maxValue).toFixed(1) : val;
    const rangeValue = this.calculateRangeValue(currentValue);
    this.props.onChange(rangeValue);
  }
  handleMouseDown(e) {
    this.onStart(e);
  }
  calculateRangeValue(value) {
    const minValue = this.props.min;
    const maxValue = this.props.max;
    const koef = (maxValue - minValue) / 100;
    // const decValue = (minValue + (value * koef)).toFixed(1);
    const decValue = ( Math.round(10 * (minValue + (value * koef))) / 10 ).toFixed(1);
    return this.props.type === 'float' ? decValue : minValue + Math.round(value * koef);
  }
  render() {
    const value = this.props.value ? this.props.value : this.props.min;
    return (
      <Wrapper disabled={this.props.isDisabled} width={this.props.width} >
        <ContainerDimensions>
          {({ width }) => {
            if (!width) return false;
            const touchClasses = ['touch'];
            if (value <= this.props.min) touchClasses.push('round-left');
            if (value >= this.props.max) touchClasses.push('round-right');
            return (
              <div className='cont' >
                <div
                  className={touchClasses.join(' ')}
                  onMouseDown={this.handleMouseDown}
                  onTouchStart={this.handleMouseDown}
                  ref={(touchControl) => { this.touchControl = touchControl; this.width = width; }}
                  style={{ left: this.getRelPosX() || 0 }}
                >
                  { this.props.preffix && <span>{this.props.preffix}</span> }
                  <span>{value}</span>
									{ this.props.suffix && <span>{this.props.suffix}</span> }
                </div>
                <div className='line' >
                  <span>&nbsp;</span>
                </div>
              </div>
            );
          }}
        </ContainerDimensions>
      </Wrapper>
    );
  }
}

export default RangerInput;



// WEBPACK FOOTER //
// ./src/html/controls/RangerInput.js